<template>
  <div>
    <header class="header">
      <h1>Currencies</h1>
      <router-link class="button" :to="{ name: 'currency-create' }">New</router-link>
    </header>

    <list-table :data="currencies">
      <template slot="thead">
        <th>Name</th>
        <th></th>
      </template>

      <template slot-scope="props">
        <td>
          <router-link :to="{ name: 'currency', params: { id: props.instance.id } }">
            {{ props.instance.name }}
          </router-link>
        </td>
        <td width="100px">
          <remove-item-button apiUrl="currencies" v-model="currencies" :id="props.instance.id"></remove-item-button>
        </td>
      </template>
    </list-table>
  </div>
</template>

<script>
import ListTable from '@/components/ListTable'
import RemoveItemButton from '@/components/RemoveItemButton'
export default {
  data () {
    return {
      currencies: []
    }
  },

  components: {
    ListTable,
    RemoveItemButton
  },

  mounted () {
    this.axios.get(`currencies`)
      .then(res => {
        this.currencies = res.data
      })
  }
}
</script>
